import React from 'react';
import { Route } from 'react-router-dom';
import { ProtectedRoute } from '../ProtectedRoute';
import UsersOverviewPage from '../../UserDashboard/admin/UsersOverviewPage';
import UserDashboardLayout from '../../UserDashboard/UserDashboardLayout';
import OverviewPage from '../../UserDashboard/OverviewPage';
import OperationsPage from '../../UserDashboard/OperationsPage';
import RoomsPage from '../../UserDashboard/RoomsPage';
import EfficacyPage from '../../UserDashboard/EfficacyPage';
import SubscriptionPage from '../../UserDashboard/SubscriptionPage';

/**
 * AdminController-only: a list of all users (`/admin/users`) and a read-only view
 * of each user's full client dashboard (`/admin/users/:email/*`). The dashboard
 * reuses the exact client pages via `UserDashboardLayout` in `adminView` mode.
 */
export const adminUserDashboardRoutes = [
  <Route
    key="admin-users"
    path="/admin/users"
    element={
      <ProtectedRoute allowedRoles={['AdminController', 'Hr']} element={<UsersOverviewPage />} />
    }
  />,
  <Route
    key="admin-user-dashboard"
    path="/admin/users/:email"
    element={
      <ProtectedRoute
        allowedRoles={['AdminController', 'Hr']}
        element={<UserDashboardLayout adminView />}
      />
    }
  >
    <Route index element={<OverviewPage />} />
    <Route path="overview" element={<OverviewPage />} />
    <Route path="operations" element={<OperationsPage />} />
    <Route path="rooms" element={<RoomsPage />} />
    <Route path="efficacy" element={<EfficacyPage />} />
    <Route path="subscription" element={<SubscriptionPage />} />
  </Route>,
];
